import styled, { css } from 'styled-components'

import { breakpoints } from '@/config/layout'

type TabType = {
  id: string
  title: string
  onClick: () => void
}

type Props = {
  tabs: TabType[]
  activeTabId: string
  variant?: 'default' | 'underline'
  className?: string
}

export const TabBar = ({ tabs, activeTabId, variant = 'default', className }: Props) => {
  return (
    <TabContainer variant={variant} className={className}>
      {tabs.map((tab) => (
        <TabItem key={tab.id} onClick={tab.onClick} active={activeTabId === tab.id} variant={variant}>
          {tab.title}
        </TabItem>
      ))}
    </TabContainer>
  )
}

const TabContainer = styled.div<{ variant: 'default' | 'underline' }>`
  display: flex;
  align-items: center;

  width: 100%;

  ${({ theme, variant }) =>
    variant === 'underline'
      ? css`
          justify-content: flex-start;
          border-bottom: 1px solid
            ${theme.Colors.Neutrals.Light || theme.Colors.Neutrals.Lighter};
          gap: ${theme.UI.SpacingPx.Space3 || theme.UI.SpacingPx.Space4};
          @media ${breakpoints.m} {
            justify-content: flex-start;
          }
        `
      : css`
          justify-content: space-between;
          align-items: center;

          @media ${breakpoints.m} {
            justify-content: flex-start;
          }
        `}
`

const TabItem = styled.div<{
  active: boolean
  variant: 'default' | 'underline'
}>`
  cursor: pointer;
  font-weight: ${({ active }) => (active ? 'bold' : 'normal')};

  ${({ theme, active, variant }) =>
    variant === 'underline'
      ? css`
          @media ${breakpoints.toS} {
            flex: 1;
            padding: ${theme.UI.SpacingPx.Space3} ${theme.UI.SpacingPx.Space2};
          }

          justify-content: center;
          align-items: center;
          text-align: center;
          padding: ${theme.UI.SpacingPx.Space4};
          color: ${active ? theme.Components.Button.Primary.Fill : theme.Colors.Neutrals.Darker};
          border-bottom: 3px solid transparent;

          ${
            active &&
            css`
            border-bottom-color: ${theme.Components.Button.Primary.Fill};
          `
          }

          &:hover {
            color: ${theme.Components.Button.Primary.Fill};
          }
        `
      : css`
          padding: ${theme.UI.SpacingPx.Space2} ${theme.UI.SpacingPx.Space4};
          border-radius: 30px;
          background-color: ${active ? theme.Colors.Neutrals.Lighter : 'transparent'};
          color: ${active ? theme.Components.Button.Primary.Fill : theme.Colors.Neutrals.Darker};

          &:hover {
            color: #2c3e50;
          }
        `}
`
